<template>
  <!--办理须知-->
  <div class="handling-instructions">
    <div class="common-width">
      <div class="common-main-body" aria-label="企业职工退休一件事办理须知">
<!--        <div class="title">-->
<!--          企业职工退休一件事办理须知-->
<!--        </div>-->
        <div class="main-content" v-html="content"></div>
      </div>
    </div>
    <div class="common-bottom">
      <div class="common-width">
        <el-button :disabled="btnDisabled" type="primary" class="next-btn" @click="goNair">我已知晓，查看下一份。<i class="time"
                                                                                                         v-if="time >= 0">{{
            `(${time}s)`
          }}</i></el-button>
      </div>
    </div>
  </div>

</template>

<script>
import {
  decryptByAES
} from '@/utils/utils';
import {
  loadDealInfo,
  doSaveSnapshot,
    baseInfo
} from '@/utils/indexUrl';
import {
  loadSSInfo
} from '@/utils/jointApplyUrl';
import {buriedPointFunc} from "../../../../assets/utils/buriedPoint";

export default {
  name: "handlingInstructions",
  data() {
    return {
      baseInfo: JSON.parse(sessionStorage.getItem('baseInfo')),
      // userInfo: JSON.parse(decryptByAES(sessionStorage.getItem('userInfo'))).userInfo,
      content: '', // 办理须知内容为富文本内容，根据后端配置而定。

      time: 5, // 倒计时数
      timer: null, // 定时器
      btnDisabled: true,
    };
  },
  computed: {},
  methods: {
      // 获取基本信息
      async getBaseInfo(typeSeq, jcAreaSeq) {
          try {
              let res = await baseInfo({
                  jcAreaSeq,
                  typeSeq
              })
              if (+res.status === 200) {
                  this.$store.commit('setBaseInfo', res.data)
                  this.baseInfo = res.data
              } else {
                  this.$message.error(res.desc || '获取基本信息失败')
              }
          } catch (err) {
              console.log(err)
              this.$message.error('获取基本信息失败')
          }
      },
    /**
     * @description: 倒计时
     */
    countDown() {
      this.timer = setInterval(() => {
        this.time--;
        if (this.time < 0) {
          this.btnDisabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    goServiceDetails() {
      this.$router.push('/serviceDetails');
    },
    async _loadSSInfo(typeSnapSeq) {
      if (!typeSnapSeq) {
        return false;
      }
      try {
        let res = await loadSSInfo({
          bizTypeSSSeq: typeSnapSeq
        });
        if (+res.status === 200) {
          sessionStorage.setItem('sSInfo', decryptByAES(res.data));
        } else {
          this.$message.error(res.desc || '获取主题快照信息失败');
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    async _doSaveSnapshot() {
      try {
        let res = await doSaveSnapshot({
          typeSeq: this.baseInfo.typeSeq,
          handleType: '1' // 办理模式（1：直接办理，2：前期辅导，3：智能引导）
        });
        if (+res.status === 200 || (+res.status === 400 && res.data)) {
          if (+res.status === 200) {
            await this._loadSSInfo(res.data.typeSnapshotSeq);
          }
        } else {
          this.$message.error(res.desc);
        }
      } catch (err) {
        this.$message.error(err);
      }

    },
    async goNair() {
      // if (this.baseInfo.surveyEnable || this.baseInfo.surveyAddEnable == 1) {
      //   this.$router.push('/questionNair')
      // } else {
      //   // 没有问卷直接生成主题快照编号，去到导办指南页面
      //   await this._doSaveSnapshot()
      //   this.$router.push('/serviceDetails?isGuidance=1')
      // }

      this.$router.push('/authorizationStatement');
    },

    getDealInfo() {
      if (this.baseInfo?.typeSeq) {
        loadDealInfo({
          typeSeq: this.baseInfo.typeSeq
        }).then(res => {
          if (res.status == 200) {
            this.content = res.data;

            this.$nextTick(() => {
              this.countDown();
            });
          } else {
            this.$message.error(res.desc);
          }
        })
      } else {
        console.log('未找到baseInfo');
      }

    }
  },
  async created() {
      let typeSeq = this.$route.query.typeSeq
      let jcAreaSeq = this.$route.query.jcAreaSeq
      if (typeSeq && jcAreaSeq && (!this.baseInfo || this.baseInfo.typeSeq != typeSeq)) {
          await this.getBaseInfo(typeSeq, jcAreaSeq)
      }
      if (!this.baseInfo) {
          this.$message.error('获取基本信息失败')
          return false
      }
    this.getDealInfo();
  },
  mounted() {
    // 进行埋点，记录页面事件
    let obj = {
      title: document.title || "", //页面名称
      actionId: "YjsNotice", //事件ID
      account: "ThemeItem", //系统标识
    };
    buriedPointFunc(obj);
  }
};
</script>

<style lang="scss" scoped>
.handling-instructions {
  margin-top: 40px;
  margin-bottom: 40px;

  .common-main-body {
    margin-bottom: 130px;

    .title {
      text-align: center;
      font-size: 24px;
      margin-bottom: 10px;
    }
  }
}
</style>
